import { Table, Space, Button, Row, Col, Input, Select, Modal, Tag, Tooltip, Pagination, } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import { customerBalanceService } from "../../../../services";
import { changeDocumentTitle } from "../../../../utils/title";

function AccountsCustomerLedger() {
  const [loading, setLoading] = useState(false);
  const [balances, setBalances] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoices, setInvoices] = useState([])


  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];
  const columns = [
    {
      title: "User",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Invoice",
      dataIndex: "invoice_amount",
      key: "invoice_amount",
      render: (text) => "$ " + text,
    },
    {
      title: "Paid",
      dataIndex: "amount",
      key: "amount",
      render: (text) => "$ " + text,
    },
    {
      title: "Balance",
      dataIndex: "Balance",
      key: "Balance",
      render: (text, record) => {
        const balance = record.invoice_amount - record.amount;
        return "$ " + balance;
      },
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text, record) => {
        const balance = record.invoice_amount - record.amount;
        const status = balance === 0 ? "Paid" : "Pending";
        return (
          <Tag
            style={{
              backgroundColor: status === "Paid" ? "#1fd655" : "yellow",
              color: status === "Paid" ? "White" : "Black",
            }}
          >
            {status}
          </Tag>
        );
      },
    },

    {
      title: "Action",
      key: "Action",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Tooltip title='View'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => openModal(record.invoices)}
            > */}
            <EyeOutlined onClick={() => openModal(record.invoices)} />
            {/* </Button> */}
          </Tooltip>
        </Space>
      ),
    },
  ];

  const openModal = (invoices) => {
    setInvoices(invoices)
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await customerBalanceService.fetch(page, pageSize);
    if (success) {
      setBalances(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Customer Balance")
    initialize(pagination.current, pagination.pageSize);
  }, []);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16}>
        <Col span={12} >
          <h1 style={{ fontWeight: "bold", padding: 10 }}>Customers Accounts Ledger</h1>
        </Col>
      </Row>

      <Modal
        title={<div style={{ width: "100%" }}>Invoice Numbers</div>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={true}
        width={850}
        style={{
          padding: "20px",
        }}
      >
        <div
          style={{
            border: "1px solid #ccc",
            padding: "20px",
            borderRadius: "12px",
          }}
        >
          {/* Scrollable Container for Invoices */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              justifyContent: "space-between",
              maxHeight: "150px", // Set the scrollable height
              overflowY: "auto", // Enable vertical scrolling
            }}
          >
            {invoices.map((invoice, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#B83D3D",
                  color: "white",
                  padding: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  textAlign: "center",
                  width: "13%", // 7 items per row (adjust for margins and gaps)
                  boxSizing: "border-box",
                }}
              >
                {invoice}
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={balances}
        rowKey='id'
        style={{ marginTop: "10px" }}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        loading={loading}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default AccountsCustomerLedger;
